import React from 'react';
import { Route, useParams, useLocation } from 'react-router-dom';
import querystringify from 'querystringify';
import { loginCallbackRoute, logoutCallbackRoute, RedirectToLogin } from '@twigeducation/oidc-client-react';
import RedirectToShortCodeUrl from './RedirectToShortCodeUrl';

const LoginRouteComponent = () => {
    const { districtId } = useParams();
    const location = useLocation();

    if (districtId) {
        return <RedirectToShortCodeUrl districtId={districtId} />;
    }
    const querystring = querystringify.parse(location.search);
    const nextUrl = querystring.next || '/';
    return <RedirectToLogin nextUrl={nextUrl} />;
};

const loginRoute = (
    <Route path="/login/:districtId?" key="login">
        <LoginRouteComponent />
    </Route>
);

export { loginCallbackRoute, logoutCallbackRoute, loginRoute };
